import { FC, MouseEvent } from 'react';
import { ISectionLink } from '@components/expertise/technologies/technologies.state';
import style from './technologies.module.scss';

interface TechnologiesNavbarProps {
    links: ISectionLink[];
}

const TechnologiesNavbar: FC<TechnologiesNavbarProps> = ({ links }) => {

    const scrollHandler = (evt: MouseEvent<HTMLAnchorElement>): void => {
        evt.preventDefault();

        const link = evt.target as HTMLAnchorElement;
        const targetId: string = link.getAttribute('href')!.slice(1);
        const targetSection = document.getElementById(targetId) as HTMLElement;

        targetSection.scrollIntoView({
            behavior: 'auto',
            block: 'center',
            inline: 'center'
        })
    };

    return (
        <div
            className={style.section__links}>
            {links.map(({ title, relatedToSection }) => (
                <a
                    key={relatedToSection}
                    href={relatedToSection}
                    className={style.section__link}
                    onClick={scrollHandler}>
                    {title}
                </a>
            ))}
        </div>
    )
}

export default TechnologiesNavbar;
